import React, {useEffect, useState} from 'react'
import {useLocation, useNavigate, useParams} from 'react-router-dom'
import {
  ModeleCentre, ModeleEquipe,
  ModeleProvenance,
  ModeleSource,
  ModeleUtilisateur,
  modeleUtilisateurInitValues,
} from '../../../components/Models'
import {editUtilisateur, getUtilisateur} from '../../../components/requests'
import {LoadingData} from '../../../components/LoadingData'
import {UtilisateurForm} from './components/UtilisateurForm'

type LocationState = {
  currentPage: number
}

const UtilisateurEditPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state as LocationState
  let {utilisateurId} = useParams()
  const [data, setData] = useState<ModeleUtilisateur>(modeleUtilisateurInitValues)
  const [loading, setLoading] = useState(true)
  const [centreSel, setCentreSel] = useState<ModeleCentre[]>([])
  const [sourceUp, setSourceUp] = useState<ModeleSource[]>([])
  const [provenanceSel, setProvenanceSel] = useState<ModeleProvenance[]>([])
  const [equipeSelected, setEquipeSelected] = useState<ModeleEquipe[]>([])
  // Récupérer la valeur du paramètre profil de l'URL
  const queryParams = new URLSearchParams(location.search)
  const showProfil = queryParams.get('profil')

  useEffect(() => {
    getUtilisateurData()
  }, [utilisateurId, showProfil])

  const getUtilisateurData = () => {
    getUtilisateur(utilisateurId)
      .then((utilisateurRequest) => {
        if (utilisateurRequest?.status === 200) {
          if (
            utilisateurRequest?.data?.utilisateur.id !== undefined &&
            utilisateurRequest.data?.utilisateur?.id !== null
          ) {
            const updatedData = Object.assign({...data}, utilisateurRequest?.data.utilisateur)

            if (updatedData.role?.id !== undefined) {
              updatedData.idRole = updatedData.role?.id
            }
            if (updatedData.serviceRattachement?.id !== undefined && updatedData.serviceRattachement?.id !== null) {
              updatedData.idServiceRattachement = updatedData.serviceRattachement?.id
            }

            setData({...updatedData})

            const transformedData = utilisateurRequest.data?.centre?.map((item) => ({
              value: item.id,
              label: item.nom,
            }))
            setCentreSel([...transformedData])

            const dataSource = utilisateurRequest.data?.sources?.map((item) => ({
              value: item.code,
              label: item.libelle,
            }))
            setSourceUp([...dataSource])

            const dataprovenance = utilisateurRequest.data?.provenance?.map((item) => ({
              value: item.id,
              label: item.libelle,
            }))
            setProvenanceSel([...dataprovenance])

            const dataEquipe = utilisateurRequest.data?.utilisateur?.utilisateurEquipes?.map((item) => ({
              value: item?.equipe?.id,
              label: item?.equipe?.nom,
            }))
            setEquipeSelected([...dataEquipe])

          }
          setLoading(false)
        } else {
          navigate(`/utilisateurs/liste`)
        }
      })
      .catch((e) => {
        setLoading(false)
        navigate(`/utilisateurs/liste`)
      })
  }

  const submitForm = async (
    fieldsToUpdate: Partial<ModeleUtilisateur>,
    callback
  ): Promise<void> => {
    const updatedData = Object.assign({...data}, fieldsToUpdate)

    var requestOk = false
    try {
      const clientRequest = await editUtilisateur(utilisateurId, updatedData)
      if (clientRequest?.status === 200) {
        requestOk = true
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback()
      if (requestOk) {
        setData({...updatedData})
        navigate(`/utilisateurs/liste`, {
          replace: true,
          state: state as LocationState
        })
      }
    }
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0'>
          <div className='card-title m-0'>
            {showProfil ? (
              <h3 className='fw-bolder m-0'>Mon profil</h3>
            ) : (
              <h3 className='fw-bolder m-0'>Modifier un utilisateur</h3>
            )}
          </div>
        </div>

        <div>
          {loading ? (
            <LoadingData />
          ) : (
            <UtilisateurForm
              utilisateurId={utilisateurId}
              data={data}
              submitForm={submitForm}
              centreSelected={centreSel}
              sourceSelected={sourceUp}
              provenanceSelected={provenanceSel}
              equipeSelected={equipeSelected}
            />
          )}
        </div>
      </div>
    </>
  )
}

export {UtilisateurEditPage}
